/**
 * @module
 *
 * @import {Amateur} from '../../amateurPool/model/amateur';
 */

import {GlobalActor, globalValue} from '@acng/frontend-relativity';
import {undefined} from '@acng/frontend-bounty/std/value.js';
import {createPromise} from '@acng/frontend-bounty/std/control.js';

import {ctxAuthUser} from '../../userPool/context/auth-user.js';
import {ctxPinsAvailable} from '../context/available.js';
import {ngDigest} from 'acng/core/service/ng.js';

const provideAvailability = GlobalActor(ctxPinsAvailable);

/**
 * @deprecated Use byAmateur instead
 *
 * @type {Amateur['id'][] & {changed: number}}
 */
// @ts-expect-error
const pins = [];
pins.changed = 0;

/**
 * @type {Set<string>}
 */
export const byAmateur = new Set();

/**
 * @deprecated Implement something different
 *
 * @type {(res: typeof pins) => void}
 */
let resolvePins;

/**
 * @deprecated Required for the onsd-thing
 *
 * @type {Promise<typeof pins>}
 */
export const promise = createPromise((resolve) => {
  resolvePins = () => resolve(pins);
});

/**
 * @param {Amateur | null} amateur
 *
 * @returns {boolean | undefined}
 */
export const checkPin = (amateur) => {
  if (!amateur || !amateur.isPinnable) {
    return undefined;
  }

  if (!globalValue(ctxAuthUser)) {
    return false;
  }

  if (!globalValue(ctxPinsAvailable)) {
    return undefined;
  }

  return byAmateur.has(amateur.id);
};

/**
 * @param {Amateur['id']} amateurId
 */
export const checkPinById = (amateurId) => byAmateur.has(amateurId);

/**
 * @deprecated Workaround for ../userPool/context/ignored-by.js
 */
export const clearPins = () => {
  provideAvailability(false);
  pins.length = 0;
  pins.changed++;
  byAmateur.clear();
};

/**
 * @deprecated Workaround for ../userPool/context/ignored-by.js
 *
 * @param {Amateur['id'][]} ids
 */
export const setPins = (ids) => {
  for (const id of ids) {
    byAmateur.add(id);
    pins.push(id);
  }
  resolvePins(pins);
  provideAvailability(true);
};

/**
 * @param {Amateur['id']} id
 */
const add = (id) => {
  if (pins.indexOf(id) < 0) {
    pins.unshift(id);
    pins.changed++;
    byAmateur.add(id);
    provideAvailability(true);
    ngDigest();
  }
};

/**
 * @param {Amateur['id']} id
 */
const remove = (id) => {
  const idx = pins.indexOf(id);
  if (idx >= 0) {
    pins.splice(idx, 1);
    pins.changed++;
    byAmateur.delete(id);
    provideAvailability(true);
    ngDigest();
  }
};

export {add as addPin, remove as removePin};
